import { render } from "./Account.vue?vue&type=template&id=6857870a&scoped=true&bindings={\"firstName\":\"options\",\"lastName\":\"options\",\"gender\":\"options\",\"dob\":\"options\",\"s\":\"options\",\"user\":\"options\",\"userName\":\"options\"}"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=6857870a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6857870a"

export default script